import { render, staticRenderFns } from "./SignupTeaFB.vue?vue&type=template&id=46ccdffe"
import script from "../../services/teacher/signup-tea-fb.js?vue&type=script&lang=js&external"
export * from "../../services/teacher/signup-tea-fb.js?vue&type=script&lang=js&external"
import style0 from "../../assets/css/teacher/signup-teacher.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports